import { IAnalysisService, AnalysisServiceImpl } from './analysis.service';

export * from './analysis.model';

export const AnalysisService: IAnalysisService = new AnalysisServiceImpl();